import {createAction} from '@reduxjs/toolkit';
import {GlobalMessageActionTypes} from '../globalMessageActionTypes';

export const showGlobalMessage = createAction(
  GlobalMessageActionTypes.SHOW_GLOBAL_MESSAGE,
  (message: GlobalMessage) => {
    return {payload: message};
  });

export const hideGlobalMessage = createAction(GlobalMessageActionTypes.HIDE_GLOBAL_MESSAGE);
